import type { ComponentProps } from 'react';

import type { PageBuilderButtonCta } from '@fhs/cms-groq-queries';
import { Button } from '@fhs/ui';

import { ActionHandler } from '../types';

import { ActionLink } from './action-link';
import { Icon } from './icon';

export type CtaButtonProps = Pick<
  PageBuilderButtonCta,
  'variant' | 'leadingIcon' | 'link' | 'trailingIcon' | 'text'
> & {
  size: ComponentProps<typeof Button>['size'];
  onAction: ActionHandler;
};

export function CtaButton(props: CtaButtonProps) {
  return (
    <ActionLink action={props.link} onAction={props.onAction} asChild>
      <Button type={props.variant} size={props.size}>
        {props.leadingIcon && (
          <Button.Icon>
            <Icon name={props.leadingIcon} />
          </Button.Icon>
        )}

        <Button.Text>{props.text}</Button.Text>

        {props.trailingIcon && (
          <Button.Icon>
            <Icon name={props.trailingIcon} />
          </Button.Icon>
        )}
      </Button>
    </ActionLink>
  );
}
